import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';
import { Category } from 'src/types/organization/category';

import { visitsApi } from '../../api/lib/visits';
import { categoriesKeys } from '../../api/query-keys/categories';

export const useCategories = () => {
  return useQuery<Category[], ApiError>({
    queryKey: categoriesKeys.list(),
    queryFn: visitsApi.fetchVisitCategories,
  });
};
